module.exports = __webpack_public_path__ + "media/img/illustrations/icons/table-escalation-exclamation-d9b2b7006c618e9fca9583bb65a00d0e.svg";